import { useNickname } from './useNickname';
import { useMembershipUserFields } from './useMembershipUserFields';

/**
 * 投稿・手書きメモ等に焼き込む「この地区での表示ニックネーム」を解決する hook。
 *
 * docs/111 Wave 3 E-2/cross-3 の恒久対処:
 *   `useNickname(districtId)` の localStorage 値が空 (onboarding 経由 / 別端末復帰 / ブラウザ
 *   データ削除) のとき、従来は呼び出し側で `anon-{uid前6}` に化けた値が authorNickname として
 *   投稿 doc へ焼き込まれていた (本番 箱根景観調査 で発生)。membership doc
 *   (`participants/{uid}/memberships/{districtId}.nickname`) は createMembership /
 *   SettingsModal が書く正規の表示名なので、localStorage が空ならこれを採用する。
 *
 * 解決順 (2026-10-09 に入替。同じ人の別端末で変えた名前がサーバー経由で membership に届くようになった
 * ため、端末内に残る古い名前より membership を優先する):
 *   1. membership doc の builtin.nickname — 正規の表示名 (別端末での変更も onMembershipWrite で届く)
 *   2. localStorage (useNickname、実 districtId 指定) — membership 読込前・読めないときの予備
 *   3. '' (空) — 上記いずれも無いとき。anon-xxxxxx 等の最終 fallback は呼び出し側の責務として残す
 *      (createMembership は nickname 必須のため、onboarding 済ユーザーでは 3 に落ちない)。
 *
 * MapPage (手書きメモ作者名) の既存インライン実装 (`localStorage || membership.builtin.nickname`)
 * を本 hook に一元化し、AppHome の投稿フローと同じ解決ロジックを共有する。
 */
export function useResolvedNickname(uid: string | null, districtId: string | null): string {
  const { nickname } = useNickname(districtId);
  const membership = useMembershipUserFields(uid, districtId);
  return (membership.values.builtin.nickname || nickname || '').trim();
}
